import React, { useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import './Home.css';

const Home = () => {
    useEffect(() => {
        document.title = "Jeledi - Le réseau social vocal";
    }, []);
    return (
        <div className="page home-page">
            <HeroSection />

            <section className="mission-section">
                <div className="container">
                    <div className="mission-content">
                        <span className="section-label">Notre Mission</span>
                        <h2 className="mission-text">
                            Notre mission est simple : libérer l’expression en donnant à chacun
                            un espace <span className="highlight">authentique</span>, <span className="highlight">naturel</span> et <span className="highlight">instantané</span> pour communiquer.
                        </h2>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
